import { useEffect, useState } from "react";
import styled from "styled-components";
import { SectionTitle, SectionSubtitle } from "components/Style";
import { SERVICES_CONTENTS } from "appLauncher";
import usePopuper from "common/usePopuper";

const Section = styled.section`
  background: #f8f8f8;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 49px;
`;

const BankTabs = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
`;

const BankTab = styled.button<{ selected?: boolean }>`
  background: ${({ selected }) => (selected ? "rgba(237, 239, 255, 1)" : "rgba(255, 255, 255, 1)")};
  color: ${({ selected }) => (selected ? "rgba(38, 64, 237, 1)" : "rgba(27, 37, 50, 1)")};
  border: 1px solid #dddddd;
  border-radius: 999px;
  padding: 8px 32px;
  font-size: 16px;
  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  cursor: pointer;
  transition: background 0.2s;
  box-shadow: ${({ selected }) =>
    selected ? "0 2px 8px rgba(38,64,237,0.08)" : "none"};
`;

const BankInfoWrap = styled.div`
  width: 1200px;
  max-width: 100%;
  margin: 32px auto 32px auto;
  display: flex;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(38, 64, 237, 0.08);
  height: 481px;
`;

const BankInfoImgArea = styled.div<{ $disabled: boolean }>`
  width: 310px;
  height: 100%;
  background: #f6f8fc;
  background-image: url(/assets/product/image.png);
  background-position: center;
  position: relative;

  @media (max-width: 1180px) {
    display: none;
  }
  > img {
    cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
    pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
  }
  > button {
    cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
    pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
    ${(props) =>
      props.$disabled
        ? `
    background: rgba(0, 0, 0, 0.04);
    color: rgba(100, 100, 100, 0.1);
    border-color: #d9d9d9;
      `
        : ""}
  }
`;

const BankInfoImg = styled.img`
  width: 184px;
  height: 238px;
  background: #f6f8fc;
  position: absolute;
  bottom: 146px;
  left: 50%;
  transform: translateX(-50%);
  object-fit: cover;
  object-position: top;
`;

const BankInfoRight = styled.div`
  padding: 32px 40px 20px 40px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-x: hidden;
  overflow-y: auto;
`;

const BankInfoDesc = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #555555;
  > div {
    margin-bottom: 16px;
  }
`;
const BankInfoFiles = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 16px;
  > div {
    flex: 1;
    min-width: calc(50% - 1em);
  }
`;
const InfoBlockTitle = styled.div`
  display: flex;
  align-items: center;
  width: 216px;
  height: 30px;
  font-weight: 600;
  font-size: 18px;
  color: #fff;
  background: linear-gradient(90deg, #2640ed 0%, #cdd3f8 53%, #ffffff 100%);
  border-radius: 18px;
  padding-left: 0;
  margin-bottom: 16px;
  position: relative;
`;
const BankImgViewBtn = styled.button`
  padding: 6px 18px;
  border-radius: 999px;
  border: 1.5px solid #2640ed;
  background: #fff;
  color: #2640ed;
  font-size: 15px;
  box-shadow: 0 2px 8px rgba(38, 64, 237, 0.08);
  position: absolute;
  bottom: 36.5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 600;
  width: 143px;
  height: 35px;
`;
const BankFileBlockTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #1b2532;
  margin-bottom: 12px;
`;

const BankFileBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  font-weight: 400;
  font-size: 14px;
  color: #555555;
`;
const BankImgMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
`;

const BankImgMaskImg = styled.img`
  max-width: 80vw;
  max-height: 80vh;
  border-radius: 16px;
  box-shadow: 0 4px 32px rgba(38, 64, 237, 0.18);
  background: #fff;
`;

const BankImgMaskClose = styled.button`
  position: fixed;
  top: 48px;
  right: 48px;
  background: #fff;
  color: #2640ed;
  border: 2px solid #2640ed;
  border-radius: 999px;
  font-size: 22px;
  font-weight: 600;
  padding: 8px 24px;
  cursor: pointer;
  z-index: 10000;
`;
function MaskImage({ url }: { url: string }) {
  const popuper = usePopuper();
  const [imgScale, setImgScale] = useState(1);
  return (
    <BankImgMask onClick={() => popuper(null)}>
      <BankImgMaskImg
        src={url}
        style={{
          transform: `scale(${imgScale})`,
          transition: "transform 0.2s",
        }}
        onClick={(e) => e.stopPropagation()}
        onWheel={(e) => {
          e.stopPropagation();
          let next = imgScale + (e.deltaY < 0 ? 0.15 : -0.15);
          next = Math.max(0.2, Math.min(next, 5));
          setImgScale(next);
        }}
      />
      <BankImgMaskClose onClick={() => popuper(null)}>关闭</BankImgMaskClose>
    </BankImgMask>
  );
}
export default function FinancialInstitutions({ index }: { index: string }) {
  const BANKS = SERVICES_CONTENTS[index as keyof typeof SERVICES_CONTENTS];
  const [selected, setSelected] = useState(0);
  const selectedBank = BANKS[selected] || { describe: "" };
  const popuper = usePopuper();
  const describe = (
    typeof selectedBank.describe === "string"
      ? [selectedBank.describe]
      : selectedBank.describe
  ).map(function (describe) {
    return typeof describe === "string"
      ? { icon: "", name: "", content: describe }
      : describe;
  });
  useEffect(() => {
    setSelected(0);
  }, [index]);

  return (
    <Section>
      <SectionTitle>金融服务机构</SectionTitle>
      <SectionSubtitle>Financial Services Institutions</SectionSubtitle>
      <BankTabs>
        {BANKS.map((bank, idx) => (
          <BankTab
            key={bank.name}
            selected={selected === idx}
            onClick={() => setSelected(idx)}
          >
            {bank.name}
          </BankTab>
        ))}
      </BankTabs>
      <BankInfoWrap>
        <BankInfoImgArea $disabled={!selectedBank.image}>
          <BankInfoImg
            src={selectedBank.image || "/assets/product/empty.png"}
            alt={selectedBank.name}
            onClick={() => {
              popuper(<MaskImage url={selectedBank.image} />);
            }}
          />
          {
            <BankImgViewBtn
              onClick={() => {
                popuper(<MaskImage url={selectedBank.image} />);
              }}
            >
              点击查看大图
            </BankImgViewBtn>
          }
        </BankInfoImgArea>
        <BankInfoRight>
          <InfoBlockTitle>
            <span style={{ marginLeft: 18, zIndex: 2 }}>办理说明</span>
          </InfoBlockTitle>
          <BankInfoDesc>
            {describe.map(function (
              e: {
                icon: string;
                name: string;
                content: string;
              },
              i
            ) {
              return (
                <div key={i}>
                  {e.icon && <img src={e.icon} />}
                  {e.name && (
                    <span style={{ fontWeight: 800 }}>{e.name}：</span>
                  )}
                  {<span>{e.content}</span>}
                </div>
              );
            })}
          </BankInfoDesc>
          <InfoBlockTitle>
            <span style={{ marginLeft: 18, zIndex: 2 }}>所需材料</span>
          </InfoBlockTitle>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {selectedBank.files.company?.length > 0 && (
              <BankFileBlockTitle>企业信息</BankFileBlockTitle>
            )}
            {selectedBank.files.company?.length > 0 && (
              <BankFileBlock style={{ flexShrink: 0, flexGrow: 2 }}>
                <BankInfoFiles>
                  {selectedBank.files.company.map((file: any, idx: number) => (
                    <div key={idx}>{file}</div>
                  ))}
                </BankInfoFiles>
              </BankFileBlock>
            )}
            {selectedBank.files.project?.length > 0 && (
              <BankFileBlockTitle>
                <span>项目材料</span>
              </BankFileBlockTitle>
            )}
            {selectedBank.files.project?.length > 0 && (
              <BankFileBlock style={{ flexShrink: 1, flexGrow: 1 }}>
                <BankInfoFiles>
                  {selectedBank.files.project.map((file: any, idx: number) => (
                    <div key={idx}>{file}</div>
                  ))}
                </BankInfoFiles>
              </BankFileBlock>
            )}
          </div>
        </BankInfoRight>
      </BankInfoWrap>
    </Section>
  );
}
